import clsx from "clsx";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { margin } from "ds_legacy/materials/metrics";
import { Title } from "ds_legacy/materials/typography";

export function PageWrapper({
  children,
  page,
}: {
  children: React.ReactNode;
  page: string;
}) {
  return (
    <VerticalLayout aligned margin={margin(2)}>
      <Title>Debug {page} encryption status</Title>
      {children}
    </VerticalLayout>
  );
}

export function DetailsTable({
  children,
  ...props
}: React.TableHTMLAttributes<HTMLTableElement>) {
  return (
    <table className="my-16 border-collapse border border-gray-200" {...props}>
      {children}
    </table>
  );
}

export function DetailsTableRow({
  children,
  onClick,
  ...props
}: React.HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={clsx("border border-gray-200", {
        "cursor-pointer hover:bg-gray-50": onClick,
      })}
      onClick={onClick}
      {...props}
    >
      {children}
    </tr>
  );
}
